module.exports = __webpack_public_path__ + "static/img/p1.3e807cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/y-dna-test/p1.jpg
// module id = 919M
// module chunks = 1